import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { BaseModelHelper } from "../helpers/base_model_helper.js";
import { CardSchemeIdHelper, OrdersApiVersion, TransactionResult, TransactionState, TransactionType } from "@biteinc/enums";
import { UniversalPaymentHelper } from "@biteinc/helpers-universal";
//#region src/utils/transaction_utils.ts
var transaction_utils_exports = /* @__PURE__ */ __exportAll({
	getGateway: () => getGateway,
	getSuccessfulSaleTransactionDatasWithoutRefunds: () => getSuccessfulSaleTransactionDatasWithoutRefunds,
	getSuccessfulSaleTransactionsWithoutRefunds: () => getSuccessfulSaleTransactionsWithoutRefunds,
	getSuccessfulTransactionsJson: () => getSuccessfulTransactionsJson,
	hasOnlyDiscountTenders: () => hasOnlyDiscountTenders,
	isDiscountTender: () => isDiscountTender,
	isLoyaltyTransaction: () => isLoyaltyTransaction,
	isOfflineApproval: () => isOfflineApproval,
	isPartiallyApproved: () => isPartiallyApproved,
	isRefund: () => isRefund,
	isSale: () => isSale,
	isSuccessful: () => isSuccessful,
	isSuccessfulPartialSale: () => isSuccessfulPartialSale,
	isSuccessfulRefund: () => isSuccessfulRefund,
	isSuccessfulSale: () => isSuccessfulSale,
	isTransactionDataALoyaltyPayment: () => isTransactionDataALoyaltyPayment,
	markAsApproved: () => markAsApproved
});
function getGateway(data) {
	return data.gateway;
}
function getSuccessfulTransactionsJson(transactions, ordersApiVersion) {
	const allowPartialApprovals = ordersApiVersion === OrdersApiVersion.V3;
	const shouldFilterLoyaltyTransactions = ordersApiVersion === OrdersApiVersion.V3;
	const refundedLoyaltyTransactionIds = transactions.filter((transaction) => {
		return transaction.isRefund() && transactions.find((txn) => {
			return txn.id.equals(transaction.data.originalTransactionId) && isLoyaltyTransaction(txn.data) && !isTransactionDataALoyaltyPayment(txn.data);
		});
	}).map((transaction) => transaction.id.toString());
	return transactions.filter((transaction) => {
		if (refundedLoyaltyTransactionIds.includes(transaction.id.toString())) return false;
		const transactionIsLoyalty = isLoyaltyTransaction(transaction.data);
		return transaction.isSuccessful(allowPartialApprovals) && (!shouldFilterLoyaltyTransactions || !transactionIsLoyalty || isTransactionDataALoyaltyPayment(transaction.data));
	}).map((transaction) => {
		return transaction.data;
	});
}
function getSuccessfulSaleTransactionsWithoutRefunds(transactions, options, shouldWhitelistRefundTransaction) {
	const transactionById = BaseModelHelper.idMap(transactions);
	const whitelist = getSuccessfulSaleTransactionDatasWithoutRefunds(transactions.map((txn) => txn.data), options, shouldWhitelistRefundTransaction ? (tData) => {
		return shouldWhitelistRefundTransaction(transactionById[tData._id.toString()]);
	} : void 0);
	const whitelistIds = new Set(whitelist.map((txn) => txn._id.toString()));
	return transactions.filter((txn) => whitelistIds.has(txn.id.toString()));
}
function getSuccessfulSaleTransactionDatasWithoutRefunds(transactions, allowances, shouldWhitelistRefundTransaction) {
	const successfulTransactions = transactions.filter((transaction) => {
		return isSuccessful(transaction, allowances);
	});
	const refundedTransactionIdMap = {};
	successfulTransactions.forEach((transaction) => {
		if (!isRefund(transaction)) return;
		if (shouldWhitelistRefundTransaction && !shouldWhitelistRefundTransaction(transaction)) return;
		const refundedTransactionId = transaction.originalTransactionId;
		refundedTransactionIdMap[refundedTransactionId.toString()] = true;
	});
	return successfulTransactions.filter((transaction) => {
		return isSale(transaction) && !refundedTransactionIdMap[transaction._id.toString()];
	});
}
function isLoyaltyTransaction(transaction) {
	return !!transaction.cardSchemeId && CardSchemeIdHelper.isLoyalty(transaction.cardSchemeId, transaction.gateway);
}
function isRefund(data) {
	return data.type === TransactionType.Refund;
}
function isSale(data) {
	return data.type === TransactionType.Sale;
}
function isSuccessful(data, allowances = {}) {
	return UniversalPaymentHelper.transactionIsSuccessful(data, allowances);
}
function isOfflineApproval(data) {
	return UniversalPaymentHelper.isOfflineApproval(data);
}
function isSuccessfulSale(data, allowances = {}) {
	return isSale(data) && isSuccessful(data, allowances);
}
function isPartiallyApproved(data) {
	return data.result === TransactionResult.PartiallyApproved;
}
function isSuccessfulPartialSale(data) {
	return isSale(data) && isPartiallyApproved(data) && isSuccessful(data, { allowPartialApprovals: true });
}
function isSuccessfulRefund(data, allowances = {}) {
	return isRefund(data) && isSuccessful(data, allowances);
}
function isTransactionDataALoyaltyPayment(transactionData) {
	return isLoyaltyTransaction(transactionData) && !!transactionData.amount;
}
function isDiscountTender(tender) {
	return "isDiscount" in tender && tender.isDiscount;
}
/**
* A transaction whose tenders are all discounts (e.g. a Punchh single-scan reward redemption) moved
* no real money, so it must not be counted as money paid. Returns false when there are no tenders so
* callers fall back to their transaction-level amount handling.
*/
function hasOnlyDiscountTenders(data) {
	return !!data.tenders?.length && data.tenders.every(isDiscountTender);
}
function markAsApproved(transaction, result, amount, transactionJson) {
	return transaction.setWithDict({
		result,
		state: TransactionState.Committed,
		amountAuthorized: amount,
		finishedAt: Date.now(),
		transactionTime: Date.now(),
		...transactionJson
	});
}
//#endregion
export { getGateway, getSuccessfulSaleTransactionDatasWithoutRefunds, getSuccessfulSaleTransactionsWithoutRefunds, getSuccessfulTransactionsJson, hasOnlyDiscountTenders, isDiscountTender, isLoyaltyTransaction, isOfflineApproval, isPartiallyApproved, isRefund, isSale, isSuccessful, isSuccessfulPartialSale, isSuccessfulRefund, isSuccessfulSale, isTransactionDataALoyaltyPayment, markAsApproved, transaction_utils_exports };

//# sourceMappingURL=transaction_utils.js.map